import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import Slider from './Scale'; // Assuming the above code is in Slider.js
import styled,{keyframes,css} from 'styled-components';


const QuestionComponent = ({
  question,
  saveUpdatedAnswers,
  currentQuestionDet,
  handlePreviousQuestion,
handleNextQuestion,
displayedQuestionIndex,
totalQuestions,
isFading,
language = 0
}) => {
  const [isDefinitionsOpen, setIsDefinitionsOpen] = useState(false);
  const [definitionsHtml, setDefinitionsHtml] = useState("");

  const formatMarkdown = (md) => {
    if (!md) return "";
    let html = md;
    html = html.replace(/^###[ \t]+(.+)$/gm, (_m, p1) => `<h3>${p1}</h3>`);
    html = html.replace(/\*\*(.+?)\*\*/g, (_m, p1) => `<strong>${p1}</strong>`);
    html = html.replace(/\n\n+/g, '<br/><br/>');
    html = html.replace(/\n/g, '<br/>');
    return html;
  };

  const openDefinitions = () => {
    const langKey = language === 1 ? 'fr' : 'en';
    const md = question?.definitions?.[langKey] || question?.definitions?.en || question?.definitions?.fr || "";
    setDefinitionsHtml(formatMarkdown(md));
    setIsDefinitionsOpen(true);
  };

  const closeDefinitions = () => {
    setIsDefinitionsOpen(false);
    setDefinitionsHtml("");
    // hard reset body overflow to ensure page is scrollable again
    document.body.style.overflow = '';
  };

  // Lock body scroll while modal open; restore on close/unmount
  React.useEffect(() => {
    if (!isDefinitionsOpen) return;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prevOverflow || '';
    };
  }, [isDefinitionsOpen]);

  return (
    <Card isFading={isFading}>
      <QuestionHeader>
        <h2>{language === 1 ? question.questionFrench || question.question : question.question}</h2>
        {question?.definitions ? (
          <DefinitionButton
            aria-label={language === 1 ? "Voir la définition" : "View definition"}
            onClick={openDefinitions}
            title={language === 1 ? "Définitions" : "Definitions"}
          >
            ?
          </DefinitionButton>
        ) : null}
      </QuestionHeader>
      <Slider
        id={question.id}
        question={question}
        saveUpdatedAnswers={saveUpdatedAnswers}
        currentQuestionDet={currentQuestionDet}
        language={language}
      />


    <ButtonContainer>
      {displayedQuestionIndex > 1 && (
          <BackButton onClick={handlePreviousQuestion}>{language === 1 ? "Retour" : "Back"}</BackButton>
        ) || (
          <div style={{ width: "100px" }}></div>
        )}
        <NextButton onClick={handleNextQuestion} disabled={currentQuestionDet === ''}>
          {displayedQuestionIndex < totalQuestions ? (language === 1 ? "Suivant" : "Next") : (language === 1 ? "Soumettre" : "Submit")}
        </NextButton>
      </ButtonContainer>
      {isDefinitionsOpen && ReactDOM.createPortal(
        (
          <ModalOverlay onClick={closeDefinitions}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
              <ModalHeader>
                <ModalTitle>{language === 1 ? "Définitions" : "Definitions"}</ModalTitle>
                <CloseButton onClick={closeDefinitions} aria-label={language === 1 ? "Fermer" : "Close"}>×</CloseButton>
              </ModalHeader>
              <ModalBody dangerouslySetInnerHTML={{ __html: definitionsHtml }} />
            </ModalContent>
          </ModalOverlay>
        ),
        document.body
      )}
    </Card>
  );
};

export default QuestionComponent;


const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(20px);
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Card = styled.div`
  width: 100%;
  max-width: 800px;
  border-radius: 10px;
  overflow: hidden;
  padding: 30px;
  margin-top: 20px;
  flex-direction: column;
  position: relative;
  animation: ${({ isFading }) =>
  isFading ? css`${fadeOut} 0.5s ease-out forwards` : css`${fadeIn} 0.5s ease-out forwards`};
`;

const QuestionHeader = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
`;

const DefinitionButton = styled.button`
  position: absolute;
  top: -2px;
  right: -4px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: none;
  background-color: #eef3ff;
  color: #2D70E2;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 2px rgba(0,0,0,0.08);
`;


const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 40px;
`;

const BackButton = styled.button`
  padding: 10px 20px;
  font-size: 1rem;
  color: #2D70E2;
  background-color: #EBF1FD;
  border: none;
  border-radius: 4px;
  cursor: pointer;
`;

const NextButton = styled.button`
  width: 170px;
  height: 47px;
  border-radius: 5px;
  background-color: #E5B63D;
  color: white;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  &:hover {
    background-color: #d4a534;
  }

  &:disabled {
    background-color: #ccc;
    color: #666;
    cursor: not-allowed;
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const ModalContent = styled.div`
  width: 100%;
  max-width: 560px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.12);
  padding: 18px 18px 14px 18px;
`;

const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

const ModalTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #2a3039;
`;

const CloseButton = styled.button`
  border: none;
  background: transparent;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  color: #7b8494;
  padding: 2px 6px;
`;

const ModalBody = styled.div`
  font-size: 14px;
  color: #2a3039;
  line-height: 1.45;
  margin-top: 6px;
  h3 {
    margin: 2px 0 2px 0;
    font-size: 16px;
    font-weight: 700;
    color: #2a3039;
    line-height: 1.3;
  }
  strong {
    font-weight: 700;
  }
`;